module.exports = __webpack_public_path__ + "img/guernsey.07a103d7.png";